import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import dayjs from "dayjs";

import { BACK_URL, apiPhpSensores } from "../../../utils/Common";
import MyLoader from "../../sharecomponents/MyLoader";

import "./sensores.css";

const Sensores_data = () => {
  const [loader, setLoader] = useState(false);
  const [sensoresData, setSensoresData] = useState([]);
  const [totalDatos, setTotalDatos] = useState(0);

  const { register, errors, handleSubmit, getValues } = useForm({
    defaultValues: {
      fecha_inicial: "",
      fecha_final: "",
    },
  });

  const exportar = () => {
    if (!validate()) {
      ToastsStore.error("Debes seleccionar las fecha inicial y final, y la fecha inicial no puede ser mayor a la fecha final");
      return;
    }

    const fi = getValues("fecha_inicial");
    const ff = getValues("fecha_final");
    console.log(fi, ff);

    setLoader(true);
    apiPhpSensores.post("exportar-datos", { fecha_inicial: fi, fecha_final: ff })
      .then(({ data }) => {
        console.log(data);
        setLoader(false);
        window.open(`${BACK_URL}/sensores/descargar`, "_blank")
      }).catch((error) => {
        console.log(error);
        setLoader(false);
      });
  }

  const submit = (data) => {
    console.log(data);

    if (!validate()) {
      ToastsStore.error("Debes seleccionar las fecha inicial y final, y la fecha inicial no puede ser mayor a la fecha final");
      return;
    }

    setLoader(true);
    apiPhpSensores
      .get("get-data", { params: data })
      .then(({ data: { data } }) => {
        console.log(data);
        const { datos, total_datos } = data;
        if (total_datos > 0) {
          setSensoresData(datos);
          setTotalDatos(total_datos);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  const validate = () => {
    const fi = getValues("fecha_inicial");
    const ff = getValues("fecha_final");

    if (fi === "" || ff === "") {
      return false;
    }

    const finicial = dayjs(fi);
    const ffinal = dayjs(ff);

    if (finicial.isAfter(ffinal)) {
      return false;
    }
    return true;
  }

  return (
    <>
      <div className="w-full p-3 right-0">
        <div className="bg-white border rounded shadow-xl">
          <div className="border-b rounded-t p-3 bg-orange-900">
            <h5 className="font-bold uppercase text-white">
              Datos de Sensores
            </h5>
            {/* <p className="text-white text-sm">Sub titulo</p> */}
          </div>
          <div className="p-5 rounded-b">
            {/* ---- CONTENIDO --- */}
            <div className="ui grid">
              <div className="eight wide column">
                {/* Formulario */}
                <form className="ui form" onSubmit={handleSubmit(submit)}>
                  <div className="fields">
                    <div className="field">
                      <label htmlFor="">Fecha Inicial:</label>
                      <input type="date" {...register("fecha_inicial")} />
                    </div>
                    <div className="field">
                      <label htmlFor="">Fecha Final:</label>
                      <input type="date" {...register("fecha_final")} />
                    </div>
                    <div className="field">
                      <button className="ui small button boton"><i className="filter icon"></i> Filtrar</button>
                      <button type="button" onClick={exportar} className="ui small blue button">
                        <i className="file excel icon"></i> Exportar Datos Filtrados
                      </button>
                    </div>
                  </div>
                </form>
                {/* ./Formulario */}
              </div>
              <div className="eight wide column"></div>
            </div>
            {totalDatos > 0 && (
              <div className="ui small blue message">
                Total Datos: {totalDatos}
              </div>
            )}
            {/* Tabla de Datos */}
            <table className="ui small table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Temperatura (&deg;C)</th>
                  <th>Humedad Relativa (%)</th>
                  <th>Radiación (w/m2)</th>
                  <th>Humedad del Suelo (%)</th>
                  <th>CO2 (ppm)</th>
                  <th>Fecha</th>
                  <th>Hora</th>
                </tr>
              </thead>
              <tbody>
                {sensoresData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.nombre}</td>
                    <td>{item.temperatura}</td>
                    <td>{item.humedad}</td>
                    <td>{item.radiacion}</td>
                    <td>{item.humedad_suelo}</td>
                    <td>{item.co2}</td>
                    <td>{item.fecha}</td>
                    <td>{item.hora}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* ./Tabla de Datos */}
          </div>
        </div>
      </div>

      {loader && <MyLoader />}
      {/* Toaster */}
      <ToastsContainer
        store={ToastsStore}
        position={ToastsContainerPosition.TOP_CENTER}
      />
      {/* ./Toaster */}
    </>
  );
};

export default Sensores_data;
